// extracted by mini-css-extract-plugin
export var content = "Tabs-module--content--fc104";
export var tabs = "Tabs-module--tabs--9f011";